module.exports = __webpack_public_path__ + "static/img/hy_wx.2674abb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hy_wx.jpg
// module id = tOor
// module chunks = 0